<app-interview-sidebar>
  <div class="resume-page full-width vertical">
    <div class="page-header full-width horizontal seperate bottom">
      <div>
        <div class="page-title margin-top vertical">Resume</div>
        <div class="description">
          AI assistant will understand the job description and requirements to optimize the guidance for you.
        </div>
      </div>
      <button nz-button nzSize="default" nzType="primary" (click)="onNewResumeClick()">
        <span nz-icon style="font-size: 16px" class="material-icons-outlined">file_upload</span>
        Upload Resume
      </button>
    </div>

    <div class="basic-block">
      <nz-table #resumeTable [nzData]="resumeList()" [nzPaginationType]="'small'" [nzPageSize]="8">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Upload Time</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (data of resumeTable.data; track data.id; let i = $index) {
            <tr>
              <td>{{ data.title }}</td>
              <td>{{ data.createdTime | toLocaleFormat: 'ff' }}</td>
              <td>
                <div class="horizontal">
                  <button nz-button nzType="text" [matTooltip]="'Download Resume'" (click)="onDownloadResumeClick(i)">
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">file_download</span>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    [nzDanger]="true"
                    [matTooltip]="'Remove'"
                    nz-popconfirm
                    nzOkText="Remove"
                    nzPopconfirmTitle="Are you sure you want to remove this resume?"
                    nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="onDeleteResumeClick(i)"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">delete_forever</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
</app-interview-sidebar>

<app-upload-resume [(isNewResumeVisible)]="isNewResumeVisible"></app-upload-resume>
